import {
  ResourceService,
} from '@/internal';

export default class MarketplaceItemService extends ResourceService {
  constructor() {
    super();
    this.baseUrl = 'marketplace';
  }

  import(id, payload = {}) {
    const {params, ...rest} = payload;

    return this.request({
      method: 'post',
      url: this.generateUrl(`${this.baseUrl}/${id}/import`, params || {}),
      params: this.prepareParams(params),
      data: this.preparePayload(rest),
    });
  }

  publishMovement(id, payload = {}) {
    const {params, ...rest} = payload;

    return this.request({
      method: 'post',
      url: this.generateUrl(`${this.baseUrl}/movement/${id}/publish`, params || {}),
      params: this.prepareParams(params),
      data: this.preparePayload(rest),
    });
  }

  publishTemplate(id, payload = {}) {
    const {params, ...rest} = payload;

    return this.request({
      method: 'post',
      url: this.generateUrl(`${this.baseUrl}/template/${id}/publish`, params || {}),
      params: this.prepareParams(params),
      data: this.preparePayload(rest),
    });
  }

  rate(id, payload = {}) {
    const {params, ...rest} = payload;

    return this.request({
      method: 'post',
      url: this.generateUrl(`${this.baseUrl}/${id}/rating`, params || {}),
      params: this.prepareParams(params),
      data: this.preparePayload(rest),
    });
  }
}
